/**
 * External dependencies
 */
import './style.scss'; // Editor only styles

import { type BlockConfiguration, registerBlockType } from '@wordpress/blocks';

/**
 * Internal dependencies
 */
import metadata from './block.json';
import { CustomerDetailsEdit } from './edit';
import { Icon } from './icon';
import { type CustomerDetailsAttributes } from './types';

/**
 * Register Customer Details block
 */
registerBlockType< CustomerDetailsAttributes >( metadata.name, {
	...( metadata as BlockConfiguration< CustomerDetailsAttributes > ),
	icon: Icon,
	edit: CustomerDetailsEdit,
} );
